var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.slaColor)?_c('v-tooltip',{attrs:{"right":"","content-class":"portal-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({attrs:{"color":_vm.slaColor,"left":""}},on),[_vm._v("notifications_active")])]}}],null,false,1234060118)},[_c('span',[_vm._v(_vm._s(_vm.slaText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }